import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70bf02ef"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "CustomSlider",
  ref: "CustomSlider"
}
const _hoisted_2 = { class: "IconWrap" }
const _hoisted_3 = { class: "IconWrap" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "HighLightCaptureText" }, "-", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSVG = _resolveComponent("InlineSVG")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["Slider", {
        NotDragging: !_ctx.dragging,
        IsGrabbing: _ctx.grabbing,
        IsDragging: _ctx.dragging
      }]),
      ref: "Slider"
    }, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], 2),
    (!_ctx.isAllItemsVisible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["Arrow Left", { IsDisabled: _ctx.activeSlide === 1 }]),
          onClickCapture: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onLeftClick && _ctx.onLeftClick(...args)))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_InlineSVG, {
              src: require('@/assets/svg/angle-left.svg')
            }, null, 8, ["src"])
          ])
        ], 34))
      : _createCommentVNode("", true),
    (!_ctx.isAllItemsVisible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["Arrow Right", { IsDisabled: _ctx.activeSlide === _ctx.totalSlides }]),
          onClickCapture: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onRightClick && _ctx.onRightClick(...args)))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_InlineSVG, {
              src: require('@/assets/svg/angle-right.svg')
            }, null, 8, ["src"])
          ])
        ], 34))
      : _createCommentVNode("", true),
    _hoisted_4
  ], 512))
}